export enum ContentGeneratorTabEnum {
  TEMPLATES = 0,
  TACTIC_ASSETS = 1,
}
